import React from "react";
import { ArrowUpFromLine, ArrowDownToLine } from "lucide-react";

const itDate = (d) => (d && d.length >= 10 ? `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)}` : "-");

export default function InventoryTable({ items, onQuickExit, onQuickEntry }) {
  if (!items.length) return <div className="bg-white border border-zinc-200 rounded-sm p-8 text-center text-zinc-400">Nessun articolo in magazzino</div>;
  return (
    <div className="bg-white border border-zinc-200 rounded-sm overflow-x-auto">
      <table className="w-full text-sm" data-testid="inventory-table">
        <thead><tr className="bg-[#09090B] text-white text-xs uppercase tracking-wider">
          <th className="px-4 py-3 text-left">Articolo</th>
          <th className="px-4 py-3 text-left">Cliente</th>
          <th className="px-4 py-3 text-right">Quantita</th>
          <th className="px-4 py-3 text-left">Unita</th>
          <th className="px-4 py-3 text-left">Posizione</th>
          <th className="px-4 py-3 text-left">Giacenza</th>
          <th className="px-4 py-3 text-left">Aggiornato</th>
          <th className="px-4 py-3 text-right w-36">Azioni</th>
        </tr></thead>
        <tbody>
          {items.map((item, i) => {
            const outOfStock = Number(item.quantity || 0) <= 0;
            return (
              <tr key={item.id || i} className="border-b border-zinc-100 hover:bg-zinc-50" data-testid={`inv-row-${i}`}>
                <td className="px-4 py-3 font-semibold">{item.item_name}</td>
                <td className="px-4 py-3 text-zinc-600">{item.company || item.client_name}</td>
                <td className={`px-4 py-3 text-right font-bold text-lg ${outOfStock ? "text-red-500" : ""}`}>{item.quantity}</td>
                <td className="px-4 py-3 text-zinc-500">{item.unit || "pz"}</td>
                <td className="px-4 py-3"><span className="bg-zinc-100 px-2 py-0.5 rounded text-xs font-mono">{item.location_code || "-"}</span></td>
                <td className="px-4 py-3" data-testid={`inv-days-${i}`}>
                  {item.storage_days === null || item.storage_days === undefined ? (
                    <span className="text-zinc-400 text-xs">-</span>
                  ) : (
                    <div className="leading-tight">
                      <span className={`inline-block px-2 py-0.5 rounded-sm text-[11px] font-bold ${item.storage_days > 30 ? "bg-amber-100 text-amber-700" : "bg-zinc-100 text-zinc-700"}`}>
                        {item.storage_days} gg
                      </span>
                      <div className="text-[10px] text-zinc-400 mt-0.5">dal {itDate(item.entry_date)}</div>
                    </div>
                  )}
                </td>
                <td className="px-4 py-3 text-zinc-400 text-xs">{item.updated_at?.slice(0,10) || "-"}</td>
                <td className="px-4 py-3 text-right">
                  <div className="inline-flex items-center gap-1">
                    <button
                      onClick={() => onQuickEntry?.(item)}
                      className="inline-flex items-center gap-1 border border-emerald-200 bg-emerald-50 text-emerald-700 px-2 py-1 text-[11px] font-bold uppercase tracking-wide rounded-sm hover:bg-emerald-100"
                      title="Carica quantità in magazzino"
                      data-testid={`inv-quick-entry-${i}`}
                    >
                      <ArrowDownToLine size={11} /> Carico
                    </button>
                    <button
                      onClick={() => onQuickExit?.(item)}
                      disabled={outOfStock}
                      className="inline-flex items-center gap-1 border border-red-200 bg-red-50 text-red-700 px-2 py-1 text-[11px] font-bold uppercase tracking-wide rounded-sm hover:bg-red-100 disabled:opacity-40 disabled:cursor-not-allowed"
                      title={outOfStock ? "Nessuna quantità disponibile" : "Scarica quantità dal magazzino"}
                      data-testid={`inv-quick-exit-${i}`}
                    >
                      <ArrowUpFromLine size={11} /> Scarico
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
